import React from 'react';
import { RELATED_PRODUCTS } from 'Cms/constants';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { COLORS } from 'Components/utils/color/colors';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { getProductProps } from 'Components/widgets/product/Product.mapper';
import { ProductTeaser } from 'Components/widgets/product-teaser/ProductTeaser';
import type { ThumbnailProduct } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { castAs } from 'Src/types/cast-helpers';
export type RelatedProductsCMSProps = {
  cruiseTimingPlaceholder: string;
  cruiseDurationPlaceholder: string;
  dateFormat: string;
  resortId: string;
  title: string;
  tourDurationPlaceholder: string;
};
export type RelatedProductsGQLProps = {
  config: {
    common: {
      close: string;
    };
    price: CMSPrice;
    resort: CMSResort;
  };
  product: {
    relatedProducts: Array<Partial<ThumbnailProduct>>;
  };
};
type LineProps = RelatedProductsCMSProps & RelatedProductsGQLProps;
export const ProductRelatedProductsLine = ({ config, product, title }: LineProps) => {
  if (!product?.relatedProducts?.length) {
    return null;
  }

  return (
    <SiteContainer className="Line Line-RelatedProducts">
      <LineTitle>{title}</LineTitle>
      {product.relatedProducts.map((relatedProduct, index) => {
        const card = {
          color: COLORS.SAFFRON,
          heading: {
            iconName: relatedProduct.resortId.toLowerCase(),
            title: relatedProduct.name,
          },
          link: {
            url: relatedProduct.href,
          },
          text: {
            text: relatedProduct.title,
          },
        };
        return (
          <article key={relatedProduct.id} className="Line Line-ProductTeaser">
            <ProductTeaser
              card={card}
              index={index}
              lineName={RELATED_PRODUCTS}
              product={getProductProps({
                config,
                product: castAs<ThumbnailProduct>(relatedProduct),
              })}
            />
          </article>
        );
      })}
    </SiteContainer>
  );
};
